// tyrant-throne.midokuni.com
import RetainOverlayTrigger from "Components/RetainOverlayTrigger";
import IStyle from "Interfaces/IStyle";
import React, { useEffect, useMemo, useState } from "react";
import { Image, Row, Table } from "react-bootstrap";
import { getJson } from "Utils/Common";
import { IStellaSoraCharacter, IStellaSoraItem, StellaSoraCharacter, StellaSoraItem } from "Views/StellaSora/Models";

const styles:IStyle = {
	cardContainer: {
		display: "flex", 
		flexDirection: "row", 
		flexWrap: "wrap",
		alignItems: "center",
	},
	iconHeaders: {width: 70, height: 70, marginLeft: 0},
	iconCells: {display: "inline-block", textAlign: "center", width: 50, height: 50, marginLeft: 5, marginRight: 5, marginTop: 0, marginBottom: 0}, //{display: "inline-block", margin: 1, textAlign: "center"}
	icon: {width: 50, height: 50},
	table: {textAlign: "center", marginLeft: "auto", marginRight: "auto"},
}
interface IMatsMemo {
	uMatGroup: StellaSoraItem[][]; 
	sMatGroup: StellaSoraItem[][]; 
	wMatGroup: StellaSoraItem[][]; 
	lovedGifts: StellaSoraItem[][]; 
	elements: string[];
}
export default function TrekkerMats() {
	const DATA_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/character.json';
	const ITEM_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/item.json';
	// const WORD_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/word.json';
	const [characters, setCharacters] = useState<StellaSoraCharacter[]>([]);
	console.log(characters);
	const {uMatGroup, sMatGroup, wMatGroup, elements} = useMemo<IMatsMemo>(()=>{
		const umats:{[str:string]: StellaSoraItem[]} = {};
		const smats:{[str:string]: StellaSoraItem[]} = {};
		const wmats:{[str:string]: StellaSoraItem[]} = {};
		const gifts:{[str:string]: StellaSoraItem[]} = {};
		// const eles: Set<string> = new Set<string>();
		const eles = ["Ignis", "Aqua", "Terra", "Ventus", "Lux", "Umbra"];
		for (const char of characters) {
			umats[char.upgradeMats.join(",")] = char.upgradeMats;
			smats[char.skillUpgradeMats.join(",")] = char.skillUpgradeMats;
			wmats[char.weeklyUpgradeMats.join(",")] = char.weeklyUpgradeMats;
			// for (const item of char.lovedGiftItems) {}
			// gifts[char.lovedGiftItems.join(",")] = char.lovedGiftItems;
			// eles.add(char.element);
		}
		const wmatList = Object.values(wmats);
		wmatList.sort((a,b)=>((a[0].id/10)%10) - ((b[0].id/10)%10));
		// {uMatGroup, sMatGroup, wMatGroup, lovedGifts, elements}
		return {
			uMatGroup: Object.values(umats), 
			sMatGroup: Object.values(smats), 
			wMatGroup: wmatList, 
			lovedGifts: Object.values(gifts), 
			elements: Array.from(eles)
		};
	}, [characters]);
	useEffect(() => {
		async function fetchData() {
			const charaTask = getJson(DATA_URL);
			const itemTask = getJson(ITEM_URL);
			const items = Object.values(await itemTask).map(item=>new StellaSoraItem(item as IStellaSoraItem));
			const charas = Object.values(await charaTask).map(chara=>new StellaSoraCharacter(chara as IStellaSoraCharacter).extractItems(items));
			charas.sort((a,b)=>a.name.localeCompare(b.name));
			setCharacters(charas);
		}
		fetchData();
	},[]);
	return (<>
	<h3 className="text-pink">Tyrant Throne - Trekker Materials</h3>
	<div style={styles.cardContainer}>
		<Table className="centered" style={styles.table} responsive variant={"violet"} striped bordered hover>
			<thead>
				<tr>
					<th rowSpan={2}></th>
					{uMatGroup.map(cell => (<th key={cell.join(",")}>{cell[0]?.name}</th>))}
					{sMatGroup.map(cell => (<th key={cell.join(",")}>{cell[0]?.name}</th>))}
				</tr>
				<tr>
					{uMatGroup.map(cell => (<th key={cell.join(",")}>{cell.map(item => <RetainOverlayTrigger overlay={<span>{item.name}</span>}><Image src={item.getIcon()} style={styles.iconHeaders} /></RetainOverlayTrigger>)}</th>))}
					{sMatGroup.map(cell => (<th key={cell.join(",")}>{cell.map(item => <RetainOverlayTrigger overlay={<span>{item.name}</span>}><Image src={item.getIcon()} style={styles.iconHeaders} /></RetainOverlayTrigger>)}</th>))}
				</tr>
			</thead>
			<tbody>
				{elements.map((ele, i) => {
					const eleChar = characters.filter(c=>c.element===ele);
					return (<tr key={ele}>
						<th><Image alt={ele} style={styles.icon} src={`https://raw.githubusercontent.com/AutumnVN/stelladb/refs/heads/main/public/${ele}.avif`} /><br></br>{ele}</th>
						{uMatGroup.map((mats, j) => (<td>
					{eleChar.filter(c=>c.upgradeMats[0]===mats[0])
					.map(c=><div key={c.id} style={styles.iconCells}>
						<RetainOverlayTrigger overlay={<span>{c.name}</span>}><Image alt={c.name} src={c.getIcon()} style={styles.icon} /></RetainOverlayTrigger>
					</div>)}</td>))}
						{sMatGroup.map((mats, j) => (<td>
					{eleChar.filter(c=>c.skillUpgradeMats[0]===mats[0])
					.map(c=><div key={c.id} style={styles.iconCells}>
						<RetainOverlayTrigger overlay={<span>{c.name}</span>}><Image alt={c.name} src={c.getIcon()} style={styles.icon} /></RetainOverlayTrigger>
					</div>)}</td>))}
					</tr>)})}
			</tbody>
		</Table>
	</div>
	<div style={styles.cardContainer}>
		<Table className="centered" style={styles.table} responsive variant={"violet"} striped bordered hover>
			<thead>
				<tr>
					<th rowSpan={2}></th>
					{wMatGroup.map(cell => (<th key={cell.join(",")}>{cell[0]?.name}</th>))}
				</tr>
				<tr>
					{wMatGroup.map(cell => (<th key={cell.join(",")}>{cell.map(item => <RetainOverlayTrigger overlay={<span>{item.name}</span>}><Image src={item.getIcon()} style={styles.iconHeaders} /></RetainOverlayTrigger>)}</th>))}
				</tr>
			</thead>
			<tbody>
				{elements.map((ele, i) => {
					const eleChar = characters.filter(c=>c.element===ele);
					return (<tr key={ele}>
						<th><Image alt={ele} style={styles.icon} src={`https://raw.githubusercontent.com/AutumnVN/stelladb/refs/heads/main/public/${ele}.avif`} /><br></br>{ele}</th>
						{wMatGroup.map((mats, j) => (<td>
					{eleChar.filter(c=>c.weeklyUpgradeMats[0]===mats[0])
					.map(c=><div key={c.id} style={styles.iconCells}>
						<RetainOverlayTrigger overlay={<span>{c.name}</span>}><Image alt={c.name} src={c.getIcon()} style={styles.icon} /></RetainOverlayTrigger>
					</div>)}</td>))}
					</tr>)})}
			</tbody>
		</Table>
	</div>

	<Row className="responsive-font"><p>The data used here is processed from <a href="https://stelladb.pages.dev">StellaDB</a></p></Row>
	<Row className="responsive-font"><p>I'm lazy to set up another webpage for SS. For now I'm putting it here.</p></Row>
	</>);
}